import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Visualization } from './components/Visualization';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { TermsModal } from './components/TermsModal';
import { PrivacyModal } from './components/PrivacyModal';
import { ContactModal } from './components/ContactModal';
import { TrustBadges } from './components/TrustBadges';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { InstitutionalQuote } from './components/InstitutionalQuote';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Bonuses } from './components/Bonuses';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalName: string) => {
    setActiveModal(modalName);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBadges data-id="element-4" />
        <Problem data-id="element-5" />
        <Solution data-id="element-6" />
        <Bonuses data-id="element-7" />
        <InstitutionalQuote data-id="element-8" />
        <WhatsIncluded data-id="element-9" />
        <Features data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Visualization data-id="element-12" />
        <FAQ data-id="element-13" />
        <CallToAction data-id="element-14" />
        <Footer onOpenModal={openModal} data-id="element-15" />
      </main>
      {activeModal === 'terms' && <TermsModal onClose={closeModal} data-id="element-16" />}
      {activeModal === 'privacy' && <PrivacyModal onClose={closeModal} data-id="element-17" />}
      {activeModal === 'contact' && <ContactModal onClose={closeModal} data-id="element-18" />}
    </div>;
}